var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8594 12.375C24.8594 19.0643 19.4374 24.4844 12.75 24.4844C6.06265 24.4844 0.640625 19.0643 0.640625 12.375C0.640625 5.6896 6.06265 0.265625 12.75 0.265625C19.4374 0.265625 24.8594 5.6896 24.8594 12.375ZM12.75 14.8164C11.5095 14.8164 10.5039 15.822 10.5039 17.0625C10.5039 18.303 11.5095 19.3086 12.75 19.3086C13.9905 19.3086 14.9961 18.303 14.9961 17.0625C14.9961 15.822 13.9905 14.8164 12.75 14.8164ZM10.6175 6.74287L10.9797 13.3835C10.9967 13.6942 11.2536 13.9375 11.5648 13.9375H13.9352C14.2464 13.9375 14.5033 13.6942 14.5203 13.3835L14.8825 6.74287C14.9008 6.40723 14.6335 6.125 14.2974 6.125H11.2025C10.8664 6.125 10.5992 6.40723 10.6175 6.74287Z",
    fill: "#C80000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.1da22482239410eb49f9e6ebd0268ca9.svg";
export { ForwardRef as ReactComponent };